
import {useReducer} from 'react';
import {shuffle} from 'lodash';

import options from './options.json';

export type Option = {
	demo: string
	goal: string
	id: string
};

export type State = {
	current: Option
	options: Option[]
};

export type Action =
  | { type: 'SELECT', id: string }
;

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'SELECT':
		return {
			...state,
			current: state.options.find(
				(o) => o.id === action.id,
			) || state.options[0],
		};
	}
};

export const useState = () => (
	useReducer(reducer, null, () => {
		const shuffled = shuffle(options);
		return {
			current: shuffled[0],
			options: shuffled,
		};
	})
);
